import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { RestfullServices } from '../shared/services/restfull.services';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private restApiService: RestfullServices) { }
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let getToken = this.restApiService.getLocalStorage('isLoggedin');
    if (getToken) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${getToken}`
        }
      });
    }
    return next.handle(request);
  }
}
